import { Component } from '@angular/core';
import { ImplementChallengeComponent } from '../implement-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-implement-challenge-action-plan',
  templateUrl: './implement-challenge-action-plan.component.html',
  styleUrls: ['./implement-challenge-action-plan.component.scss']
})
export class ImplementChallengeActionPlanComponent {

  constructor(public implementChallengeComponent: ImplementChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const raw = this.implementChallengeComponent?.short_content || [];
    const context = raw
      .filter((item: any) => item && item.todo)
      .map((item: any) => item.todo);
    this.aiService.openSidebar(
      'implement', 'action-plan', context,
      'Generate 5 action plan items {persona} for implementing the solution. Current context: {context}',
      'short_content', this.implementChallengeComponent
    );
  }
}
